import React, { Component } from 'react';
import { Link } from 'react-router';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import { getCaseType } from '../../utils/db';
import { sortData } from '../../common/globals';
import Bugsnag from '../../helpers/bugsnag';

class CaseType extends Component {
  constructor(props) {
    super(props);

    this.state = {
      caseType: [],
      selectedType: '',
      active: null
    };
  }

  _onSelectedType = (selectedData, index = null) => {
    try {
      const { onHideShowCaseType } = this.props;
      const { active, isCaseType } = this.state;
      if (active === index) {
        this.setState({ active: null, selectedType: '' });
      } else {
        onHideShowCaseType(selectedData);
        this.setState({ active: index, selectedType: selectedData, isCaseType: !isCaseType });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectedCaseType = (position) => {
    try {
      const { active } = this.state;
      if (active === position) {
        return 'selected';
      }
      return '';
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const unSortCaseType = await getCaseType();
      const caseType = sortData(unSortCaseType, 'OptionName');
      caseType && this.setState({ caseType });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { caseType } = this.state;
    return (
      <section>
        <section className="section">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <ul className="select-list list-unstyled cursor-pointer">
                  {
                    caseType.length > 0
                      ? caseType.map((data, index) => (
                        <Link
                          key={index}
                          onClick={() => { this._onSelectedType(data, index); }}
                        >
                          <li
                            className={this._onSelectedCaseType(index)}
                          >
                            {data.OptionName}
                          </li>
                        </Link>
                      ))
                      : <div className="text-center">No case types available</div>
                  }
                </ul>
              </div>
            </div>
          </div>
        </section>
      </section>
    );
  }
}

export default withNotify(withLoader(CaseType));
